<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p>
        <span class="breadcrumb-item" @click="$router.push('/dashboard')">Inicio</span>
        &rsaquo; Solicitudes de Tipster
      </p>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador mb-4">
          <div class="titulo">
            <h5 class="mx-4 mt-5 mb-1">Solicitudes de Tipster</h5>
            <p class="mx-4 mb-3 text-sm opacity-7">Gestión de solicitudes de alta recibidas desde el formulario de login.</p>
          </div>
          <div class="filtros-grid px-4 pb-4">
            <div class="filtro-item filtro-q">
              <label class="filtro-label">Buscar</label>
              <input v-model="buscar" type="text" class="form-control form-control-sm" placeholder="Nombre, email, canal..." @keyup.enter="cargar(1)" />
            </div>
            <div class="filtro-item">
              <label class="filtro-label">Estado</label>
              <select v-model="estadoFiltro" class="form-control form-control-sm" @change="cargar(1)">
                <option value="pendiente">Pendientes</option>
                <option value="aprobada">Aprobadas</option>
                <option value="rechazada">Rechazadas</option>
                <option value="todos">Todos</option>
              </select>
            </div>
            <div class="filtro-item filtro-btns">
              <QBtn variant="tipster" :label="loading ? 'Cargando...' : 'Buscar'" :loading="loading" :disabled="loading" @click="cargar(1)" />
              <QBtn variant="neutro" label="Limpiar" @click="limpiar" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card ficha-listado">
          <div class="px-4 py-3 card-body">
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <p class="text-sm mb-0 opacity-7">
                <span v-if="!loading">{{ total.toLocaleString('es-ES') }} solicitud{{ total !== 1 ? 'es' : '' }}</span>
                <span v-else>Cargando...</span>
              </p>
            </div>

            <div class="table-responsive">
              <table class="table table-empirulada">
                <thead class="thead-light">
                  <tr>
                    <th>#</th>
                    <th>Nombre</th>
                    <th class="d-none d-md-table-cell">Email</th>
                    <th class="d-none d-md-table-cell">Canal</th>
                    <th class="d-none d-lg-table-cell">Suscriptores</th>
                    <th class="d-none d-lg-table-cell">País</th>
                    <th>Estado</th>
                    <th class="d-none d-md-table-cell">Fecha</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <tr v-if="loading">
                    <td colspan="9" class="text-center py-4 opacity-6">
                      <div class="spinner-border spinner-border-sm text-primary me-2"></div>Cargando...
                    </td>
                  </tr>
                  <tr v-else-if="items.length === 0">
                    <td colspan="9" class="text-center py-5 opacity-6">No hay solicitudes en este estado.</td>
                  </tr>
                  <tr v-for="s in items" :key="s.id">
                    <td>{{ s.id }}</td>
                    <td>
                      <div>{{ s.nombre }}</div>
                      <div class="text-xs opacity-7 d-md-none">{{ s.email }}</div>
                    </td>
                    <td class="d-none d-md-table-cell">{{ s.email }}</td>
                    <td class="d-none d-md-table-cell">{{ s.canal_principal }}</td>
                    <td class="d-none d-lg-table-cell">{{ Number(s.num_suscriptores).toLocaleString('es-ES') }}</td>
                    <td class="d-none d-lg-table-cell">{{ s.pais }}</td>
                    <td>
                      <span class="badge-estado" :class="claseEstado(s.estado)">{{ s.estado }}</span>
                    </td>
                    <td class="d-none d-md-table-cell">{{ fmtFecha(s.created_at) }}</td>
                    <td>
                      <div class="acciones-btns">
                        <button v-if="s.estado === 'pendiente'" class="btn-accion btn-aprobar" :disabled="procesando === s.id" @click="confirmarAprobar(s)">
                          {{ procesando === s.id && accionActiva === 'aprobar' ? '...' : '✅ Aprobar' }}
                        </button>
                        <button v-if="s.estado === 'pendiente'" class="btn-accion btn-rechazar" :disabled="procesando === s.id" @click="abrirRechazar(s)">
                          ❌ Rechazar
                        </button>
                        <button class="btn-accion btn-detalle" @click="verDetalle(s)">
                          👁 Ver
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="paginas > 1" class="paginacion mt-3">
              <button class="pag-btn" :disabled="pagina <= 1" @click="cargar(pagina - 1)">‹ Anterior</button>
              <template v-for="p in paginasVisibles" :key="p">
                <span v-if="p === '...'" class="pag-dots">…</span>
                <button v-else class="pag-btn" :class="{ 'pag-btn--activo': p === pagina }" @click="cargar(p)">{{ p }}</button>
              </template>
              <button class="pag-btn" :disabled="pagina >= paginas" @click="cargar(pagina + 1)">Siguiente ›</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal: Rechazar -->
  <div v-if="modalRechazar" class="modal-overlay" @click.self="cerrarRechazar">
    <div class="modal-box">
      <h6>Rechazar solicitud #{{ rechazarSolicitud?.id }}</h6>
      <p class="text-sm opacity-7">{{ rechazarSolicitud?.nombre }} — {{ rechazarSolicitud?.email }}</p>
      <label class="text-xs font-weight-bold mt-2">Motivo del rechazo (opcional)</label>
      <textarea v-model="rechazarNotas" class="form-control mt-1" rows="3" placeholder="Opcional..."></textarea>
      <div class="d-flex gap-2 mt-3">
        <QBtn variant="danger" label="Rechazar" :disabled="procesando !== null" @click="ejecutarRechazar" />
        <QBtn variant="neutro" label="Cancelar" @click="cerrarRechazar" />
      </div>
    </div>
  </div>

  <!-- Modal: Detalle -->
  <div v-if="modalDetalle" class="modal-overlay" @click.self="modalDetalle = false">
    <div class="modal-box modal-box--detalle">

      <!-- Cabecera -->
      <div class="det-header">
        <div class="det-header__left">
          <span class="det-id">#{{ detalleItem?.id }}</span>
          <span class="badge-estado" :class="claseEstado(detalleItem?.estado)">{{ detalleItem?.estado }}</span>
        </div>
        <button class="det-close" @click="modalDetalle = false">✕</button>
      </div>

      <!-- Nombre grande -->
      <div class="det-nombre">{{ detalleItem?.nombre }}</div>

      <!-- Grid de datos -->
      <div class="det-grid">
        <div class="det-campo">
          <span class="det-label">📧 Email</span>
          <span class="det-valor">{{ detalleItem?.email }}</span>
        </div>
        <div class="det-campo">
          <span class="det-label">📱 Teléfono</span>
          <span class="det-valor">{{ detalleItem?.telefono }}</span>
        </div>
        <div class="det-campo">
          <span class="det-label">🌍 País</span>
          <span class="det-valor">{{ detalleItem?.pais }}</span>
        </div>
        <div class="det-campo">
          <span class="det-label">📅 Fecha</span>
          <span class="det-valor">{{ fmtFecha(detalleItem?.created_at) }}</span>
        </div>
        <div class="det-campo det-campo--full">
          <span class="det-label">📢 Canal principal</span>
          <span class="det-valor det-valor--highlight">{{ detalleItem?.canal_principal }}</span>
        </div>
        <div class="det-campo det-campo--full">
          <span class="det-label">👥 Suscriptores</span>
          <span class="det-valor det-suscriptores">{{ Number(detalleItem?.num_suscriptores || 0).toLocaleString('es-ES') }}</span>
        </div>
        <div v-if="detalleItem?.notas" class="det-campo det-campo--full">
          <span class="det-label">📝 Notas</span>
          <span class="det-valor">{{ detalleItem?.notas }}</span>
        </div>
        <div class="det-campo">
          <span class="det-label">🌐 IP</span>
          <span class="det-valor det-valor--muted">{{ detalleItem?.ip || '—' }}</span>
        </div>
      </div>

      <!-- Acciones si está pendiente -->
      <div v-if="detalleItem?.estado === 'pendiente'" class="det-acciones">
        <button class="btn-accion btn-aprobar btn-accion--lg" :disabled="procesando === detalleItem?.id" @click="confirmarAprobar(detalleItem); modalDetalle = false">
          ✅ Aprobar solicitud
        </button>
        <button class="btn-accion btn-rechazar btn-accion--lg" :disabled="procesando === detalleItem?.id" @click="abrirRechazar(detalleItem); modalDetalle = false">
          ❌ Rechazar
        </button>
      </div>

      <div class="det-footer">
        <button class="det-btn-cerrar" @click="modalDetalle = false">Cerrar</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/apiClient.js";
import showSwal from "/src/mixins/showSwal.js";

export default {
  name: "SolicitudesTipster",

  data() {
    return {
      items: [],
      total: 0,
      pagina: 1,
      paginas: 1,
      porPagina: 20,
      loading: false,
      buscar: '',
      estadoFiltro: 'pendiente',
      procesando: null,
      accionActiva: null,

      modalRechazar: false,
      rechazarSolicitud: null,
      rechazarNotas: '',

      modalDetalle: false,
      detalleItem: null,
    };
  },

  computed: {
    paginasVisibles() {
      const p = this.pagina, t = this.paginas, arr = [];
      for (let i = 1; i <= t; i++) {
        if (i === 1 || i === t || Math.abs(i - p) <= 2) arr.push(i);
        else if (arr[arr.length - 1] !== '...') arr.push('...');
      }
      return arr;
    },
  },

  mounted() {
    this.cargar(1);
  },

  methods: {
    async cargar(pag = 1) {
      this.loading = true;
      this.pagina = pag;
      try {
        const { data } = await api.get('/api/v2/solicitudes-tipster', {
          params: { estado: this.estadoFiltro, buscar: this.buscar, pagina: pag },
        });
        this.items = data.data || [];
        this.total = data.total || 0;
        this.paginas = Math.ceil(this.total / (data.porPagina || 20));
      } catch (err) {
        showSwal.methods.showSwal({ type: "error", message: "Error cargando solicitudes." });
      } finally {
        this.loading = false;
      }
    },

    limpiar() {
      this.buscar = '';
      this.estadoFiltro = 'pendiente';
      this.cargar(1);
    },

    async confirmarAprobar(s) {
      if (!confirm(`¿Aprobar solicitud de ${s.nombre} (${s.email})?\n\nSe creará un usuario con rol tipster y se le enviarán las credenciales por email.`)) return;
      this.procesando = s.id;
      this.accionActiva = 'aprobar';
      try {
        await api.post(`/api/v2/solicitudes-tipster/${s.id}/aprobar`, {});
        showSwal.methods.showSwal({ type: "success", message: `Solicitud aprobada. Credenciales enviadas a ${s.email}.` });
        this.cargar(this.pagina);
        // el badge del sidebar se actualiza al recargar la siguiente vez
      } catch (err) {
        const msg = err?.response?.data?.mensaje || 'Error al aprobar.';
        showSwal.methods.showSwal({ type: "error", message: msg });
      } finally {
        this.procesando = null;
        this.accionActiva = null;
      }
    },

    abrirRechazar(s) {
      this.rechazarSolicitud = s;
      this.rechazarNotas = '';
      this.modalRechazar = true;
    },

    cerrarRechazar() {
      this.modalRechazar = false;
      this.rechazarSolicitud = null;
    },

    async ejecutarRechazar() {
      if (!this.rechazarSolicitud) return;
      this.procesando = this.rechazarSolicitud.id;
      try {
        await api.post(`/api/v2/solicitudes-tipster/${this.rechazarSolicitud.id}/rechazar`,
          { notas: this.rechazarNotas }
        );
        showSwal.methods.showSwal({ type: "success", message: "Solicitud rechazada." });
        this.cerrarRechazar();
        this.cargar(this.pagina);
        // el badge del sidebar se actualiza al recargar la siguiente vez
      } catch (err) {
        showSwal.methods.showSwal({ type: "error", message: "Error al rechazar." });
      } finally {
        this.procesando = null;
      }
    },

    verDetalle(s) {
      this.detalleItem = s;
      this.modalDetalle = true;
    },

    fmtFecha(dt) {
      if (!dt) return '—';
      const d = new Date(dt);
      return d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })
        + ' ' + d.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
    },

    claseEstado(estado) {
      if (estado === 'pendiente') return 'badge-estado--pendiente';
      if (estado === 'aprobada') return 'badge-estado--aprobada';
      if (estado === 'rechazada') return 'badge-estado--rechazada';
      return '';
    },
  },
};
</script>

<style scoped>
.filtros-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  align-items: flex-end;
}
.filtro-item { display: flex; flex-direction: column; gap: 0.2rem; }
.filtro-q { flex: 1 1 220px; }
.filtro-item:not(.filtro-q):not(.filtro-btns) { flex: 0 0 160px; }
.filtro-btns { flex: 0 0 auto; display: flex; gap: 0.5rem; align-items: flex-end; }
.filtro-label { font-size: 0.75rem; font-weight: 600; opacity: 0.75; margin-bottom: 0; }

.badge-estado {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 20px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: capitalize;
}
.badge-estado--pendiente { background: #fff3cd; color: #856404; }
.badge-estado--aprobada  { background: #d1e7dd; color: #0f5132; }
.badge-estado--rechazada { background: #f8d7da; color: #842029; }

.acciones-btns { display: flex; gap: 0.35rem; flex-wrap: wrap; }
.btn-accion {
  border: none;
  border-radius: 0.4rem;
  padding: 0.25rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity .2s;
  white-space: nowrap;
}
.btn-accion:disabled { opacity: 0.55; cursor: not-allowed; }
.btn-aprobar { background: #d1e7dd; color: #0f5132; }
.btn-rechazar { background: #f8d7da; color: #842029; }
.btn-detalle { background: #e2e8f0; color: #344767; }
.btn-accion:not(:disabled):hover { opacity: 0.75; }

.paginacion { display: flex; gap: 0.3rem; align-items: center; flex-wrap: wrap; }
.pag-btn {
  border: 1px solid #dee2e6; background: transparent; border-radius: 0.35rem;
  padding: 0.2rem 0.55rem; font-size: 0.8rem; cursor: pointer;
}
.pag-btn--activo { background: #203353; color: #fff; border-color: #203353; }
.pag-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.pag-dots { padding: 0.2rem 0.3rem; font-size: 0.8rem; opacity: 0.6; }

.modal-overlay {
  position: fixed; inset: 0; z-index: 1060;
  background: rgba(0,0,0,0.6);
  display: flex; align-items: center; justify-content: center;
  padding: 1rem;
}
.modal-box {
  background: var(--q-card, #1a2332);
  color: var(--q-text, #c8d6e5);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 0.85rem;
  padding: 1.5rem;
  width: 100%;
  max-width: 500px;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 12px 40px rgba(0,0,0,0.55);
}
.modal-box h6 {
  font-weight: 700;
  margin-bottom: 0.15rem;
  color: var(--q-text, #c8d6e5);
}
.modal-box .table {
  color: var(--q-text, #c8d6e5);
}
.modal-box .table th {
  color: var(--q-gold, #f5a623);
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  padding-right: 1rem;
  border-color: rgba(255,255,255,0.07);
}
.modal-box .table td {
  border-color: rgba(255,255,255,0.07);
  font-size: 0.85rem;
}

/* ── Modal Detalle "empirulado" ── */
.modal-box--detalle {
  max-width: 560px;
  padding: 0;
  overflow: hidden;
}

.det-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.1rem 1.4rem 0.8rem;
  border-bottom: 1px solid rgba(255,255,255,0.07);
  background: rgba(255,255,255,0.03);
}
.det-header__left {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}
.det-id {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  opacity: 0.45;
  font-variant-numeric: tabular-nums;
}
.det-close {
  background: none;
  border: none;
  color: var(--q-text, #c8d6e5);
  opacity: 0.45;
  font-size: 1rem;
  cursor: pointer;
  padding: 0.2rem 0.4rem;
  border-radius: 0.3rem;
  line-height: 1;
  transition: opacity 0.15s;
}
.det-close:hover { opacity: 0.85; }

.det-nombre {
  padding: 1.1rem 1.4rem 0.5rem;
  font-size: 1.35rem;
  font-weight: 700;
  color: #fff;
  letter-spacing: -0.01em;
  line-height: 1.2;
}

.det-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  padding: 0.5rem 1.4rem 1rem;
}
.det-campo {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.65rem 0;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}
.det-campo--full {
  grid-column: 1 / -1;
}
.det-label {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--q-gold, #f5a623);
  opacity: 0.85;
}
.det-valor {
  font-size: 0.9rem;
  color: var(--q-text, #c8d6e5);
  word-break: break-word;
}
.det-valor--highlight {
  font-weight: 600;
  color: #fff;
}
.det-valor--muted {
  opacity: 0.5;
  font-size: 0.8rem;
  font-variant-numeric: tabular-nums;
}
.det-suscriptores {
  font-size: 1.4rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #fff;
  letter-spacing: -0.02em;
}

.det-acciones {
  display: flex;
  gap: 0.6rem;
  padding: 0.8rem 1.4rem;
  border-top: 1px solid rgba(255,255,255,0.07);
  background: rgba(255,255,255,0.02);
}
.btn-accion--lg {
  flex: 1;
  padding: 0.55rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 0.5rem;
}

.det-footer {
  padding: 0.7rem 1.4rem;
  border-top: 1px solid rgba(255,255,255,0.06);
  display: flex;
  justify-content: flex-end;
}
.det-btn-cerrar {
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.1);
  color: var(--q-text, #c8d6e5);
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.4rem 1rem;
  border-radius: 0.4rem;
  cursor: pointer;
  transition: background 0.15s;
}
.det-btn-cerrar:hover { background: rgba(255,255,255,0.1); }

@media (max-width: 480px) {
  .det-grid { grid-template-columns: 1fr; }
  .det-campo--full { grid-column: 1; }
  .det-acciones { flex-direction: column; }
  .btn-accion--lg { text-align: center; }
}
</style>
